/** Phi logo assets (public/Images/phi). */

export const PHI_LOGO = {
  horizontal: {
    default: "/Images/phi/phi-logo-horizontal-colored-hand-dark-text.png",
    onDark: "/Images/phi/phi-logo-horizontal-colored-hand-white-text.png"
  },
  vertical: {
    default: "/Images/phi/phi-logo-vertical-logo.png",
    onDark: "/Images/phi/phi_logo-vertical-logo-black.png"
  }
};
